import React, { useEffect, useState } from "react"
import { Modal, Form, Row, Col ,Button} from "antd"
import { ApiCalls } from "../../../shared/ApiCalls"
import { MyInput } from "../../Forms"
import { useTranslation } from "react-i18next"

const AddEditBoxModal = ({open, onClose, editbox, getAllApplications }) => {
    
    const [form] = Form.useForm()
    const [loading, setLoading ] = useState(false)  
    const { t } = useTranslation()

    useEffect(() => {
        if (open && editbox) {
            form.setFieldsValue({...editbox})
        } else {
            form.resetFields()
        }
    }, [open, editbox])

    const onFinish = async () => {
        try {
            let formData= await form.validateFields()
            setLoading(true)
            formData= {
                ...formData,
                addedFor: 1
            }
            const result = await ApiCalls.boxManagementGo.addEditBox({...formData, id: editbox?.id});
            setLoading(false)
            if(result){
                closeDrawer()
                getAllApplications()
            }
        } catch (error) {
            console.error("Form validation error:", error);
        }
    }
    const closeDrawer= ()=>{
        form.resetFields()
        onClose()
    }

  return (
    <div>
        <Modal
            title={editbox ? t('Edit Box') : t('Add Box')}
            onCancel={closeDrawer}
            open={open}
            width={600}
            centered
            footer={[
                <Button 
                    size="large"
                    onClick={closeDrawer}
                    key="cancel"
                >
                    {t('Cancel')}
                </Button>,
                <Button  
                    size="large"
                    type="primary"
                    htmlType="submit"
                    loading={loading}
                    onClick={()=> form.submit()}
                    key="submit"
                >
                    {editbox ? t('Update box') : t('Save box')}
                </Button>
            ]}
        >
            <Form
                form={form}
                layout="vertical"
                onFinish={onFinish}
            >
                <Row gutter={16}>
                    <Col span={24}>
                        <MyInput
                            label={t('Serial number')}
                            name='serialNo'
                            placeholder={t('e.g 1234')}
                            required
                            message={t('please enter serial number')}
                            size='large'
                        />
                    </Col>
                    <Col span={24}>
                        <MyInput
                            label={t('MAC address')}
                            name='macAddress'
                            placeholder={t('e.g 00:B0:D0:63:C2:46')}
                            required
                            message={t('please enter mac address')}
                            onChange={(e) => {
                                const inputValue = e.target.value;
                                const cleanedValue = inputValue.replace(/\W/g, '');
                                const formattedMacAddress = cleanedValue.match(/.{1,2}/g)?.join(':').slice(0, 17) || '';
                                form.setFieldsValue({ ...form?.getFieldsValue(), macAddress: formattedMacAddress });
                            }} 
                            size='large'
                        />
                    </Col>
                </Row>
            </Form>
        </Modal>
    </div>
  )
}

export {AddEditBoxModal}
